import { takeLatest, put } from 'redux-saga/effects';
import { reloadTxnOpps, editTxnOpp, setChannelWorkflowLoadingOverlayState, appNotify } from 'store/actions';
import { postWithToken } from 'api/network';

export function* reloadTxnOppsSaga() {
  yield takeLatest(reloadTxnOpps, function* ({ payload: txnOppIds }) {
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Reloading TxnOpps...' }));
      yield postWithToken(`/api/underwrite/workflow/opportunity/reload`, txnOppIds);
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
    }
  });
    
  yield takeLatest(editTxnOpp, function* ({ payload }) {
    const { request, callback } = payload;
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Editing TxnOpp...' }));
      const res = yield postWithToken(`/api/underwrite/prop/edit`, request);
      const data = yield res.json();
      callback(data);
    } catch (error) {
      console.log(error);
      callback(); // Call callback without arg to stop loading in Edit modal
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
    }
  });
}